"use strict";
exports.__esModule = true;
exports.getChainID = exports.getWallet = exports.fetchGet = exports.withInterval = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var chain_provider_1 = require("../factory/chain-provider");
var ethers_1 = require("ethers");
function withInterval(func) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var updates;
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, func()];
                case 1:
                    updates = _a.sent();
                    if (updates) {
                        return [2 /*return*/, updates];
                    }
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var interval = setInterval(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var updates;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, func()];
                                        case 1:
                                            updates = _a.sent();
                                            if (updates) {
                                                clearInterval(interval);
                                                if (updates instanceof Error)
                                                    reject(updates);
                                                else
                                                    resolve(updates);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, (0, lodash_1.random)(5000, 10000));
                        })];
            }
        });
    });
}
exports.withInterval = withInterval;
function fetchGet(url, params) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (params)
                        url = "".concat(url, "?").concat((new URLSearchParams(params)).toString());
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    });
}
exports.fetchGet = fetchGet;
function getWallet(pkOrProvider, chainID) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(typeof pkOrProvider === 'string')) return [3 /*break*/, 2];
                    _a = ethers_1.Wallet.bind;
                    _b = [void 0, pkOrProvider];
                    return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainID)];
                case 1: return [2 /*return*/, new (_a.apply(ethers_1.Wallet, _b.concat([(_c.sent())])))()];
                case 2: return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainID, pkOrProvider)];
                case 3: return [2 /*return*/, (_c.sent()).getSigner()];
            }
        });
    });
}
exports.getWallet = getWallet;
function getChainID(pkOrProvider, chainID) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var hexChainID;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof pkOrProvider === 'string')
                        return [2 /*return*/, chainID];
                    return [4 /*yield*/, pkOrProvider.request({ method: 'eth_chainId' })];
                case 1:
                    hexChainID = _a.sent();
                    return [2 /*return*/, parseInt(hexChainID)];
            }
        });
    });
}
exports.getChainID = getChainID;
